import type { z } from "zod";

import { backofficeFindModulatorResponseRawSchema } from "~infrastructure/api/backoffice/contract/devices/responses/backoffice-find-modulator-response.ts";

export const backofficeFindPilotModulatorsResponseSchema = backofficeFindModulatorResponseRawSchema.array();

export type BackofficeFindPilotModulatorsResponse = z.infer<typeof backofficeFindPilotModulatorsResponseSchema>;
